angular.module('core').filter('minutes', ['$filter', 'numberFilter',
	function($filter, $numberFilter) {
		return function(milliseconds, unabbreviated) {
      var label = unabbreviated ? 'nMinutes' : 'nMin';

			if (_.isUndefined(milliseconds) || !_.isNumber(milliseconds) || isNaN(milliseconds)) {
				return $filter('translate')('shared.' + label, {count: 0});
			}

      var value = $numberFilter(Math.round((milliseconds / 1000) / 60));
      return $filter('translate')('shared.' + label, {count: value});
		};
	}
]);
